<template>
  <div>
    <b-row class="variant-item">
      <b-col cols="12">
        <span class="variant-barcode">
          Barkod: {{ variant.barcode || '-' }}
          <feather-icon
            v-if="variant.barcode"
            icon="CopyIcon"
            size="14"
            class="variant-copy"
            @click="doCopy(variant.barcode)"
          />
        </span>
        &nbsp;&nbsp;
        <a
          v-if="variant.url"
          :href="variant.url"
          target="_blank"
          rel="noopener noreferrer"
          class="variant-link"
          title="Barkod Linki"
        >
          <feather-icon
            icon="LinkIcon"
            size="14"
          />
        </a>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <product-sub-products
          :product="product"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import copyMixins from '@/mixins/copyMixins'
import ProductSubProducts from '@/views/v2/trendyol/product/ProductSubProducts.vue'

export default {
  name: 'ProductVariantItem',
  components: {
    ProductSubProducts,
  },
  mixins: [copyMixins],
  props: {
    variant: {
      type: Object,
      required: true,
    },
    product: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style scoped>
.variant-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.variant-barcode {
  font-size: 0.9rem;
}

.variant-link {
  display: inline-flex;
  color: inherit;
}

.variant-copy {
  cursor: pointer;
  margin-left: 6px;
}
</style>
